import { useDateFormatter } from '@bluebeam/react-i18n';
import Drive from 'components/Icons/Drive';
import FileIcon from 'components/Icons/File';
import Folder from 'components/Icons/Folder';
import { StdListCell, StdListCheckbox, StdListRow } from 'components/StdList';
import moment from 'moment';
import React from 'react';
import {
  FileBrowserDrive,
  FileBrowserFile,
  FileBrowserFolder,
  FileBrowserSite,
} from './FileBrowser';

export type FileBrowserRowItem =
  | {
      type: 'file';
      value: FileBrowserFile;
    }
  | {
      type: 'folder';
      value: FileBrowserFolder;
    }
  | {
      type: 'drive';
      value: FileBrowserDrive;
    }
  | {
      type: 'site';
      value: FileBrowserSite;
    };
interface Props {
  checkbox: 'unchecked' | 'checked' | 'indeterminate' | 'hidden';
  item: FileBrowserRowItem;
  onClick?: () => void;
  onSelect?: () => void;
  fadedText?: boolean;
}

const FileBrowserRow: React.FC<Props> = (props: Props) => {
  const dateFormatter = useDateFormatter({
    dateStyle: 'medium',
  });
  const { checkbox, item, onClick, onSelect, fadedText: faded } = props;
  const itemId = item.value.id.toString();

  const rowId = `file-browser-row-${item.value.id}`;

  const createIcon = () => {
    switch (item.type) {
      case 'drive':
        return <Drive />;
      case 'folder':
        return <Folder />;
      default:
        return <FileIcon />;
    }
  };

  const style: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    fontWeight: item.type === 'folder' ? 'bold' : 'normal',
    opacity: faded ? 0.25 : 1,
  };

  return (
    <StdListRow id={itemId} onClick={onClick} selected={checkbox === 'checked'}>
      {checkbox === 'hidden' ? (
        <StdListCell id={`${rowId}-cell-empty`}> </StdListCell>
      ) : (
        <StdListCheckbox
          rowId={itemId}
          disabled={!onSelect}
          onChange={() => {
            if (onSelect) {
              onSelect();
            }
          }}
          indeterminate={checkbox === 'indeterminate'}
          checked={checkbox === 'checked'}
        />
      )}
      <StdListCell id={`${rowId}-cell-name`} style={style}>
        {item.type !== 'site' && <div className="mr2">{createIcon()}</div>}
        {item.value.name}
      </StdListCell>
      <StdListCell
        id={`${rowId}-cell-date`}
        style={{ paddingLeft: '2.625rem', opacity: faded ? 0.25 : 1 }}
      >
        {item.type === 'file' &&
          dateFormatter?.format(moment(item.value.updatedAt).toDate())}
      </StdListCell>
    </StdListRow>
  );
};

export default FileBrowserRow;
